import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import QuizPresenterLive from '../components/QuizPresenterLive';

export default function QuizPresenterPage() {
  const { quizId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const handleClose = () => {
    window.close();
    // Fallback if window.close doesn't work
    window.location.href = '/';
  };

  return (
    <QuizPresenterLive
      quizId={quizId}
      presenterToken={token}
      onClose={handleClose}
    />
  );
}
